module.exports = __webpack_public_path__ + "london-9cdb45c8498ff41e8b3af1b22225fce1.bundle.jpg";